import React from 'react';
import moment from 'moment';
import { StyledAlert } from '../../styled';

const FALLBACK_OPENING_TIME = '08:30 am';
const FALLBACK_CLOSING_TIME = '18:30 pm';

const parseTime = (timeString) => moment(timeString, 'HH:mm a');

const isOutsideWorkingHours = (time, garage) => {
  const garageOpeningTime = parseTime(garage.openingHour || FALLBACK_OPENING_TIME);
  const garageClosingTime = parseTime(garage.closingHour || FALLBACK_CLOSING_TIME);
  return time.isBefore(garageOpeningTime) || time.isAfter(garageClosingTime);
};

const getWarningWording = (collectionTime, deliveryTime, garage) => {
  const badCollectionTime = isOutsideWorkingHours(collectionTime, garage);
  const badDeliveryTime = isOutsideWorkingHours(deliveryTime, garage);

  if (badCollectionTime && badDeliveryTime)
    return `Collection & delivery time are out of garage working hours!`;

  if (badCollectionTime) return `Collection time is out of garage working hours!`;

  if (badDeliveryTime) return `Delivery time is out of garage working hours!`;

  return null;
};

const OutOfHoursWarning = ({ garage, collectionTime, deliveryTime }) => {
  if (!garage) return '';

  const message = getWarningWording(parseTime(collectionTime), parseTime(deliveryTime), garage);

  if (!message) return '';

  return <StyledAlert message={message} type="warning" />;
};

export default OutOfHoursWarning;
